import { render, staticRenderFns } from "./PartnersTable.vue?vue&type=template&id=3ae519c6"
import script from "./PartnersTable.vue?vue&type=script&lang=js"
export * from "./PartnersTable.vue?vue&type=script&lang=js"
import style0 from "./PartnersTable.vue?vue&type=style&index=0&id=3ae519c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataFooter,VDataTable,VSpacer,VToolbar})
